<template>
	<div>
    <!-- 选择类型 -->
    <back :title="titlename"></back>
    <div class="ywlx">
      <p>请选择办理方式</p>
	    <router-link :to="{path:'/Appointment',query:{sxid:this.$route.query.sxid}}">网格办</router-link>
      <router-link :to="{path:'/Door',query:{sxid:this.$route.query.sxid}}">上门办</router-link>

    </div>
	</div>

</template>

<script>

export default {
    data() {
      return {
        titlename:"公司变更",
        type:"",
        ywid:""
      };
    },
    created:function(){
      this.ywid=this.$route.query.ywId
      this.type=this.$route.query.type
      this.titlename=this.$route.query.name
    },
    methods:{
      //跳转

    }
  };
</script>

<style lang="less" scoped>
  .ywlx{
    font-size: .3rem;
    color: #333;
    padding: 1.74rem .9rem .1rem;
    text-align: center;
    p{
      margin-bottom: 1rem;
      display: block;
    }
    a{
      font-size: .34rem;
      display: block;
      color: #333;
      background: #fafafa;
      padding:.33rem 0rem;
      margin-top: .454rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/serviceway.vue